export default __webpack_public_path__ + "static/media/evo-dropdown.a9b49bf1.webp";